import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, UrlTree } from '@angular/router';
import { Location } from '@angular/common';
import { Observable } from 'rxjs';
import { SessionService } from '../session/session.service';
import { BaseParamsService } from '../base-params.service';
import { map } from 'rxjs/operators';
import { REDIRECT_QUERY_PARAM } from '@app/core/consts';

@Injectable()
export class SignedInGuard implements CanActivate, CanActivateChild {
  private router = inject(Router);
  private location = inject(Location);
  private sessionService = inject(SessionService);
  private baseParamsService = inject(BaseParamsService);


  public canActivate(next: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    this.baseParamsService.parseParams(next);
    return this.sessionService.isBasicallyAuthenticated()
      .pipe(
        map((isAuthenticated) => {
          if (isAuthenticated) {
            return true;
          }
          return this.getSignUpPageUrlTree();
        }),
      );
  }

  public canActivateChild(childRoute: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this.canActivate(childRoute);
  }

  private getSignUpPageUrlTree(): UrlTree {
    const params = new URLSearchParams();
    params.set(REDIRECT_QUERY_PARAM, this.location.path());
    const url = `${this.baseParamsService.getRootURI()}?${params.toString()}`;
    return this.router.parseUrl(url);
  }
}
